/* 
MIT License
Copyright 2024 kazir
https://gist.github.com/kazifr/0414af6e04ce6d1b4866c9d600e021e5

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the “Software”), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

var
SlowVideo,
opt_windowWidth,
opt_windowHeight,
s,
i,
flag = 1,
external_single_loaded = 1;
function opt_init() {

lazyLoadCss(),

flag && ((flag = 0), load_all_js());
}
function insertAfter(t, e) {
e.parentNode.insertBefore(t, e.nextSibling);
}

function SlowLoadVideo() {
SlowVideo.forEach(function (t) {
t.src = (t.dataset.src == null ? t : t.dataset).src;
});
}

function lazyLoadCss() {
var t = document.querySelectorAll("link[data-href]");
for (i = 0; i < t.length; i++) {
var e = document.createElement("link");
(e.href = t[i].getAttribute("data-href")), (e.rel = "stylesheet"), t[i].parentNode.insertBefore(e, t[i]), delete t[i].dataset.href, t[i].parentNode.removeChild(t[i]);
}
}
function lazyLoadStyle() {
var t = document.querySelectorAll("style[type=lazyload2]");
for (i = 0; i < t.length; i++) {
var e = document.createElement("style");
(e.innerHTML = t[i].innerHTML), t[i].parentNode.insertBefore(e, t[i]), t[i].parentNode.removeChild(t[i]);
}
}

function opt_load_js_uri(t) {
var e = document.createElement("script");
if (t.attributes !== void 0) for (var o, a = 0, n = t.attributes, i2 = n.length; a < i2; a++) (o = n[a]).nodeName != "data-src" && o.nodeName != "type" && e.setAttribute(o.nodeName, o.nodeValue);
return (e.src = t.getAttribute("data-src")), insertAfter(e, t), delete t.dataset.src, delete t.type, t.parentNode.removeChild(t), e;
}
function opt_load_inline_js_single(t) {
if (!external_single_loaded)
return (
setTimeout(function () {
opt_load_inline_js_single(t);
}, 200),
!1
);
s = document.createElement("script");
for (var e = 0; e < t.attributes.length; e++) {
var o = t.attributes[e];
o.name != "type" && s.setAttribute(o.name, o.value);
}
(s.innerHTML = t.innerHTML), insertAfter(s, t), t.parentNode.removeChild(t);
}
function lazyLoadScripts() {
var t,
e = document.querySelectorAll("script[type=slowloadscript]");
if (e.length < 1) return document.body.classList.add("opt_loaded"), void fullJSLoadedCB();
e[0].getAttribute("data-src") !== null
? (((t = opt_load_js_uri(e[0])).onload = function () {
lazyLoadScripts();
}),
(t.onerror = function () {
lazyLoadScripts();
}))
: (opt_load_inline_js_single(e[0]), lazyLoadScripts());
}
function optAnalytics() {
document.querySelectorAll(".analytics").forEach(function (t) {
(trekkie.integrations = !1), ((s = document.createElement("script")).innerHTML = t.innerHTML), insertAfter(s, t), t.parentNode.removeChild(t);
});
}
function optBoomerang() {
document.querySelectorAll(".boomerang").forEach(function (t) {
(window.BOOMR.version = !1), ((s = document.createElement("script")).innerHTML = t.innerHTML), insertAfter(s, t), t.parentNode.removeChild(t);
});
}
function load_all_js() {
Shopify.designMode || -1 < window.location.href.indexOf("/cart") || -1 < window.location.href.indexOf("/checkout")
? console.log("Opt in progress")
: (console.log("Optimized"),
setTimeout(function () {
var t = document.createEvent("Event");
t.initEvent("opt_load", !0, !0), window.document.dispatchEvent(t);
}, 500),
setTimeout(function () {
var t = document.createEvent("Event");
t.initEvent("DOMContentLoaded2", !0, !0), window.document.dispatchEvent(t);
}, 5e3)),
lazyLoadScripts()

}
function fullJSLoadedCB() {
setTimeout(function () {});
}
document.addEventListener("DOMContentLoaded", function () {
(opt_windowWidth = screen.width),
(opt_windowHeight = screen.height),
(SlowVideo = document.querySelectorAll("source")),
window.addEventListener("scroll", function () {
opt_init();
}),
window.addEventListener("mousemove", function () {
opt_init();
}),
window.addEventListener("touchstart", function () {
opt_init();
});
});
